module.exports = __webpack_public_path__ + "static/media/message.9c71760c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footer/message.svg
// module id = 644
// module chunks = 0